/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { useStaticQuery, graphql, Link, navigate } from "gatsby"
import Img from "gatsby-image"
import { useTranslation } from "react-i18next"
import axios from "axios"
import Icon from "@mdi/react"
import { mdiEarth, mdiChevronRight } from "@mdi/js"
import _ from "lodash"
import Header from "../components/header"
import Nav from "../components/Nav"
import { GlobalStyle, ResetStyle } from "../components/globalStyle"
import ControlGroup from "../components/ControlGroup"
import { useDebounce } from "../utils"
import withI18next from "../i18n/withI18next"
import ClientSideQuestionList from "../components/ClientSideQuestionList"

const FAQ_API_SEARCH = (lang, query) => `/${lang}/cdn/faq?keyword=${query}`

const Wrapper = styled.div`
  /* margin: 0 59px; */
  /* min-width: 1200px; */
  min-width: 1200px;
  @media screen and (max-width: 414px) {
    min-width: 414px;
  }

  main {
    margin: 0 45px;
  }
`

const CompanyLogo = styled.div`
  margin: 50px 45px;
  margin-bottom: 0px;
  img {
    margin: auto;
    text-align: center;
    display: inherit;
  }

  /* @media (min-width: 768px) {
    margin: 50px 45px;
    margin-bottom: 0px;
  } */

  @media screen and (max-width: 414px) {
    display: flex;
    justify-content: center;
  }
`

const ContentSection = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 35px;

  .upSales {
    border: 1px solid var(--ud-greyeb);
    box-sizing: border-box;
    border-radius: 3px;
    width: 33.3%;
    display: table;
    .title {
      font-weight: bold;
      line-height: normal;
      font-size: 16px;
      color: black;
      margin: 24px 18px 7px 18px;
    }
    .tagname {
      margin: 0px 18px;
      margin-bottom: 10px;
      line-height: normal;
      font-size: 14px;
      a {
        color: #337ab7;
        text-decoration: none;
        margin-right: 10px;
      }
    }
    .externalLink {
      border-top: 1px solid var(--ud-greyeb);
      padding: 13px 18px;
      font-size: 14px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      color: #337ab7;
      text-decoration: none;
      margin-right: 10px;
      svg {
        color: black;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  @media screen and (max-width: 415px) {
    flex-direction: column;
    margin: 0 25px;

    .upSales {
      width: 100%;
    }
  }
`

const SupportPageList = styled.div`
  min-height: 500px;
  width: 66.6%;
  padding-right: 24px;
  /* float: left; */
  @media screen and (max-width: 414px) {
    width: 100%;
    padding-right: 0px;
  }
`

const SupportPageListItem = styled(Link)`
  width: 100%;
  min-height: 100px;
  border-bottom: 1px solid var(--ud-greyeb);
  padding: 0px 15px;
  color: black;
  display: block;
  .supportPage__listItemQuestion {
    padding: 13px 0px 9px 0px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    text-decoration: none;
    width: 100%;
    display: flex;
    align-items: center;
    color: black;
    svg {
      margin-right: 15px;
    }
  }
  &:hover {
    .supportPage__listItemQuestion {
      text-decoration: underline;
    }
  }

  .supportPage__listItemPreview {
    font-weight: normal;
    font-size: 14px;
    color: var(--ud-grey3c);
    margin: 0px 0px 15px 0px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  &.skeleton {
    width: 100%;
    .supportPage__listItemQuestion span {
      background-color: #f1f1f1;
      width: 75%;
      height: 25px;
      position: relative;
      overflow: hidden;
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        animation: shimmer 2s infinite;
        content: "";
      }
    }
    > span {
      background-color: #f1f1f1;
      width: 100%;
      height: 38px;
      display: block;
      position: relative;
      overflow: hidden;
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        animation: shimmer 2s infinite;
        content: "";
      }
    }

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  }
`

const pageLimit = 5

const Questions = ({ t, questionList, offset = 0, location, loading }) => {
  if (loading) {
    return (
      <SupportPageList>
        {Array.from({ length: 5 }).map(() => {
          return (
            <SupportPageListItem as="div" className="skeleton">
              <div className="supportPage__listItemQuestion skeleton">
                <span className="skeleton" />
              </div>
              <span className="skeleton" />
            </SupportPageListItem>
          )
        })}
      </SupportPageList>
    )
  }
  if (questionList && !_.isEmpty(questionList)) {
    const questions = questionList
      .slice(offset, offset + pageLimit)
      .map(faq => (
        <SupportPageListItem key={faq.id} to={`${faq.lang}/faq/${faq.id}`}>
          <div className="supportPage__listItemQuestion">
            <Icon path={mdiEarth} size={0.5} />
            <span dangerouslySetInnerHTML={{ __html: `${faq.title}` }} />
          </div>
          <span dangerouslySetInnerHTML={{ __html: `${faq.preview}` }} />
        </SupportPageListItem>
      ))
    return <SupportPageList>{questions}</SupportPageList>
  }
  return (
    <SupportPageList>
      <span>{t("no_data_available")}</span>
    </SupportPageList>
  )
}

const Layout = ({ children, location, pageContext }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      logoImage: file(relativePath: { eq: "ud-logo.png" }) {
        childImageSharp {
          fixed(height: 95, width: 92) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  const { locale, categoryUrlList = [], currentCatUrl, type } = pageContext
  const { i18n, t } = useTranslation()
  const [queryString, setQueryString] = useState("")
  const [loading, setLoading] = useState(false)
  const [searchResult, setSearchResult] = useState([])
  const debouncedQueryString = useDebounce(queryString, 500)

  useEffect(() => {
    i18n.changeLanguage(locale)
  }, [location, i18n, locale])

  useEffect(() => {
    if (debouncedQueryString !== "") {
      axios
        .get(
          `${process.env.ENV_FAQ_API_ROOT_URL}${FAQ_API_SEARCH(
            locale,
            debouncedQueryString
          )}`
        )
        .then(result => {
          setSearchResult(result.data)
          setLoading(false)
          console.log(result)
        })
        .catch(e => {
          setLoading(false)
        })
    }
  }, [debouncedQueryString, locale])

  const searchFaq = e => {
    navigate(`/${i18n.language}`)
    setQueryString(e.target.value)
    setLoading(true)
  }

  return (
    <>
      <ResetStyle />
      <GlobalStyle />
      <Header location={location} />
      <Nav />
      <Wrapper>
        <CompanyLogo>
          <Img fixed={data.logoImage.childImageSharp.fixed} />
        </CompanyLogo>
        <ControlGroup
          categoryUrlList={categoryUrlList}
          locale={locale}
          searchFaq={searchFaq}
          queryString={queryString}
          currentCatUrl={currentCatUrl}
        />
        <ContentSection>
          {queryString !== "" && type === "listing" ? (
            <ClientSideQuestionList
              // t={t}
              questionList={searchResult}
              location={location}
              loading={loading}
            />
          ) : (
            <>{children}</>
          )}
          <div className="upSales">
            <div className="title">{t("support_people_also_looking_for")}</div>
            <div className="tagname">
              <a
                href="https://www.udomain.hk/cloud-server"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("support_cloud_service")}
              </a>
              <a
                href="https://www.udomain.hk/cloud-storage"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("support_cloud_storage")}
              </a>
              <a
                href="https://www.udomain.hk/solution/icp-free-china-cdn"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("support_china_solution")}
              </a>
            </div>
            <a
              href="https://www.udomain.hk/sc/customer/case-study"
              className="externalLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("support_case_study")}
              <Icon path={mdiChevronRight} color="black" size={"16px"} />
            </a>
            <a
              href="https://www.udomain.hk/sc/customer"
              className="externalLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("support_our_customer")}
              <Icon path={mdiChevronRight} color="black" size={"16px"} />
            </a>
            <a
              href="https://www.udomain.hk/sc/about/alliance"
              className="externalLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("support_our_partner")}
              <Icon path={mdiChevronRight} color="black" size={"16px"} />
            </a>
          </div>
        </ContentSection>
      </Wrapper>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default withI18next()(Layout)
